<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="toggleDialog"
    max-width="1100"
  >
    <v-card>
      <v-row class="fluid justify-space-between align-top ma-2">
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h5 font-weight-medium">Preview Prompt</span>

          <v-chip
            v-if="cardDescription"
            :color="chipColor"
            size="small"
            variant="outlined"
            class="ml-2 text-indigo-darken-4"
          >
            <span class="text-truncate" style="max-width: 250px">{{ cardDescription }}</span>
          </v-chip>
        </v-card-title>
        <v-btn variant="text" icon color="grey" @click="toggleDialog(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-card-text class="pt-2">
        <div
          class="code-surface pa-4"
          role="region"
          aria-label="Prompt preview"
        >
          <pre><code>{{ content }}</code></pre>
        </div>
      </v-card-text>

      <v-card-actions class="justify-space-between">
        <div class="text-caption text-medium-emphasis">
          Press Esc to close
        </div>
        <div class="d-flex ga-2">
          <v-btn variant="text" @click="download">Download</v-btn>
          <v-btn color="primary" @click="copy">{{ 'Copy' }}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const { modelValue, content, cardDescription } = defineProps({ modelValue: Boolean, content: String, cardDescription: String })
const emit = defineEmits(['update:modelValue'])

const store = useStore()

const colors = { command: 'blue-lighten-1', readmodel: 'green-lighten-1', entity: 'amber-darken-1', gwt: 'purple-lighten-1' }
const chipColor = computed(() => colors[cardDescription.split(':')[0].toLowerCase()])

const toggleDialog = (value) => {
  emit('update:modelValue', value)
}

const copy = async () => {
  await navigator.clipboard.writeText(content)
  store.commit('snackbar/showMessage', { content: 'Copied!', timeout: 3000, color: 'blue' }, { root: true })
}

const download = () => {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = 'prompt.md'
  a.click()
  URL.revokeObjectURL(a.href)
}
</script>

<style scoped>
.code-surface {
  white-space: pre-wrap;
  background: #0b1020;
  color: #e8eaf6;
  border-radius: 12px;
  max-height: 70vh;
  overflow: auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
  line-height: 1.5;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #aaa;
    background-origin: content-box;
  }
}
</style>
